import React, {Fragment, JSX, useEffect, useMemo, useRef, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Button, CloseButton, Col, Container, FloatingLabel, Form, Nav, Row, Spinner, Table} from 'react-bootstrap';
import "leaflet/dist/leaflet.css";
import * as turf from 'turf'
import {
    FeatureGroup,
    LayerGroup,
    LayersControl,
    MapContainer,
    Marker,
    Polygon,
    Popup,
    TileLayer,
    useMap
} from 'react-leaflet'
import L, {Icon} from 'leaflet';
import marker from '../../assets/marker.svg';
import "./Profile.css"
import ProfilePagination from './ProfilePagination';
import {itemsToPolygons} from '../../utils/itemsToPolygons';
import {connect} from 'react-redux';
import axiosHandler from "../../services/https";
import MapitalyModal from "../MapitalyModal";
import {logout} from "../../action/auth";
import {
    ArrowClockwise,
    ArrowDown,
    BoxArrowRight, Check,
    Exclamation,
    HourglassBottom,
    HourglassSplit
} from 'react-bootstrap-icons';
import "../../../node_modules/leaflet/dist/leaflet.css"
import "../../../node_modules/leaflet-draw/dist/leaflet.draw.css"
import {EditControl} from "react-leaflet-draw";
import * as Leaflet from "leaflet";
import {geojsonToWKT} from "@terraformer/wkt";
import {addItemsToQueue} from "../../action/download";

export const markerIcon = new Icon({
    iconUrl: marker,
    iconSize: [32, 32]
})

const { BaseLayer } = LayersControl

export function FlyToMap({center, zoom}) {
    //esportata per usare anche in profiledetails, wrappato in graffe per passare piu elementi in caso
    const map = useMap();

    useEffect(() => {
        map.flyTo(center, zoom);
    }, [map, center, zoom]);

    return null;
}

export const formatDate = (date) => {
    const date1 = new Date(date);
    return date1.toUTCString() // .toLocaleString()
}

const capitalizeFirst = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

const Profile = ({isAuthenticated, user, logout, addItemsToQueue}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [validFilterForm, setValidFilterForm] = useState(null);

    const filteredSearch = (tab, page) => {
        if (!tab) {
            tab = activeTab
        }
        if (!page) {
            page = currentPage
        }
        const paginationString = `limit=10&page=${page}`
        setIsLoading(true);
        if (tab === "orders") {
            const wkt = currentAOI ? geojsonToWKT(currentAOI.geometry) : null;
            const apiData = {}
            if (filterForm.dateFrom) {
                apiData['date_from'] = filterForm.dateFrom;
            }
            if (filterForm.dateTo) {
                apiData['date_to'] = filterForm.dateTo;
            }
            if (filterForm.input) {
                apiData['description'] = filterForm.input;
            }
            if (filterForm.status) {
                apiData['status'] = filterForm.status;
            }
            if (wkt) {
                apiData['wkt'] = wkt;
            }
            if (currentAOI && currentAOI.properties.radius) {
                apiData['radius'] = currentAOI.properties.radius;
            }
            const searchDataString = Object.keys(apiData).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(apiData[key])
            }).join('&');
            fetchFilteredOrderList(searchDataString ? (paginationString + "&" + searchDataString) : paginationString).then((data) => {
                setOrderList(data.results);
                setTotalOnDemandPages(data.total_pages);
                setLinkTabOD(data.links);
                setTotalItems(data?.total_items);
                setError(null)
            }).catch((error) => {
                setCurrentPage(1);
                setTotalOnDemandPages(1);
                setOrderList(null);
                setLinkTabOD([]);
                setTotalItems(0);
                setError('Error fetching on-demand data');
            }).finally(() => {
                setIsLoading(false);
                setValidFilterForm(null);
            });
        } else if (tab === "downloads") {
            // Downloads
            fetchProductList(paginationString).then((data1) => {
                setProductList(data1.downloads);
                setTotalDownloadPages(data1.total_pages);
                setLinkTabDL(data1.links);
                setTotalItems(data1?.total_items);
                setError(null)
            }).catch((error) => {
                setCurrentPage(1);
                setProductList(null);
                setTotalDownloadPages(1);
                setLinkTabDL([]);
                setTotalItems(0);
                setError('Error fetching downloads data');
            }).finally(() => {
                setIsLoading(false);
            });
        }
    }

    const mapRef = useRef(null);

    // leaflet draw -----------------------

    const drawRef = useRef(null);
    const [currentAOI, setCurrentAOI] = useState(null);

    const handleAOIdraw = (e) => {
        // remove all previously selected shapes
        Object.keys(drawRef.current._layers)
            .filter((id) => {
                const element = drawRef.current._layers[id]
                return element._leaflet_id !== e.layer._leaflet_id && element.options.color === '#3388ff' // rimuovi i layer di questo colore, che saranno le AOI
            })
            .forEach((id) => {
                drawRef.current.removeLayer(drawRef.current._layers[id]);
            });
        // setting new AOI
        const aoi = e.layer.toGeoJSON();
        if (aoi.geometry.type === 'Point') {
            aoi.properties.radius = e.layer.options.radius / 1000;
        }
        setCurrentAOI(aoi);
    };

    const handleAOIdeletion = (e) => {
        setCurrentAOI(null);
    };

    // filter form ------------------------

    const initialFilterForm = {
        aoi: null,
        input: '',
        status: '',
        dateFrom: '',
        dateTo: '',
        user: '',
        lastUpdate: null
    };
    const [filterForm, setFilterForm] = useState(initialFilterForm);

    const resetFilterForm = () => {
        setFilterForm(initialFilterForm);
        setValidFilterForm(null);
    }

    const handleFilterFormChange = (e) => {
        setFilterForm({...filterForm, [e.target.name]: e.target.value});
        // validation
        if (filterForm.dateFrom && filterForm.dateTo) {
            if (filterForm.dateFrom > filterForm.dateTo) {
                setValidFilterForm(false);
            } else {
                setValidFilterForm(true);
            }
        }
    }

    const handleFilterFormSubmit = () => {
        if (validFilterForm !== false) {
            // search
            setValidFilterForm(true);
            filteredSearch(activeTab, 1); // trigger the filtered search
        }
    }


    const renderFilterForm = () => (
            <Form id="filterForm" className="filterForm">
                <Row className="justify-content-between align-items-center">
                    <Col className="col-auto">
                        <Form.Label style={{    borderBottom: `1px solid darkgray`}}>Filter current data</Form.Label>
                    </Col>
                    <Col className="col-auto">
                        {isLoading &&
                            <Spinner
                                animation="border" role="status" style={{marginRight: '15px', verticalAlign: 'middle'}}>
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>}
                        <CloseButton style={{verticalAlign: 'middle'}} onClick={resetFilterForm} />
                    </Col>
                </Row>
                <Form.Group className="mt-3">
                    <FloatingLabel label="Order Description">
                        <Form.Control placeholder="Input description" onChange={handleFilterFormChange} value={filterForm.input} size="sm" id="input" type="text"
                                      name="input"></Form.Control>
                    </FloatingLabel>
                </Form.Group>
                <Form.Group className="mt-3">
                    <FloatingLabel label="Order Status">
                        <Form.Select id="status" name="status" onChange={handleFilterFormChange} value={filterForm.status} aria-label="Pick status">
                            <option value="-"></option>
                            <option value="finished">Finished</option>
                            <option value="running">Running</option>
                        </Form.Select>
                    </FloatingLabel>
                </Form.Group>
                <Form.Group className="mt-3">
                    <FloatingLabel label="Date from">
                        <Form.Control
                            onChange={handleFilterFormChange}
                            isInvalid={validFilterForm === false}
                            type="date"
                            id="dateFrom"
                            name="dateFrom"
                            value={filterForm.dateFrom}
                        />
                    </FloatingLabel>
                </Form.Group>
                <Form.Group className="mt-3">
                    <FloatingLabel label="Date to">
                        <Form.Control
                            onChange={handleFilterFormChange}
                            isInvalid={validFilterForm === false}
                            type="date"
                            id="dateTo"
                            name="dateTo"
                            value={filterForm.dateTo}
                        />
                    </FloatingLabel>
                </Form.Group>
                {/*<Form.Group className="mt-3">*/}
                {/*    <FloatingLabel label="Requesting User">*/}
                {/*        <Form.Select onChange={handleFilterFormChange} id="user" name="user" aria-label="Pick user">*/}
                {/*            <option value="-"></option>*/}
                {/*        </Form.Select>*/}
                {/*    </FloatingLabel>*/}
                {/*</Form.Group>*/}
                <div className="mt-3 d-grid gap-2">
                    <Button className="button1" disabled={isLoading || validFilterForm === false} type="button" onClick={handleFilterFormSubmit}>Filter</Button>
                </div>
            </Form>
    )

    // ------------------------------------

    const navigate = useNavigate();
    useEffect(() => {
        if (!isAuthenticated || !user) {
            navigate("/");
        }
    }, [isAuthenticated, user]);

    const [selected, setSelected] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    const [activeTab, setActiveTab] = useState('orders');
    const [selectedCurrentItems, setSelectedCurrentItems] = useState([]);
    const [selectedDownloads, setSelectedDownloads] = useState([]);
    const [currentMapKey, setCurrentMapKey] = useState("map-0");
    const [totalItems, setTotalItems] = useState(0);

    const renderColumnNames = (tab, columns) => {

        if (tab === "downloads") {
            return <tr>
                <th align='center'>
                    <input
                        type="checkbox"
                        name="selectedItem"
                        checked={selectAllChecked}
                        onChange={(e) => e.target.checked ? handleSelectAll() : handleDeselectAll()}
                    />
                </th>
                {columns.map((column, index) => (
                    <th key={`dwncol-${index}`}>{column}</th>
                ))}
            </tr>
        } else {
            return <tr>
                {columns.map((column, index) => (
                    <th key={`ordcol-${index}`}>{column}</th>
                ))}
            </tr>
        }
    };

    //Downloads
    const fetchProductList = async (dataString) => {
        return axiosHandler.getInstance().get(`${process.env.REACT_APP_MAPIT_API_URL}${process.env.REACT_APP_MAPIT_API_DOWNLOADS}?${dataString}`)
            .then((response) => {
                return response.data;
            })
    };

    const fetchFilteredOrderList = async (dataString) => {
        return axiosHandler.getInstance().get(`${process.env.REACT_APP_MAPIT_API_URL}${process.env.REACT_APP_MAPIT_API_JOBS}?${dataString}`)
            .then((response) => {
                return response.data;
            })
    };

    const [orderList, setOrderList] = useState(null);
    const [productList, setProductList] = useState(null);

    // Variabile per i Link
    const [linkTabDL, setLinkTabDL] = useState([]);
    const [linkTabOD, setLinkTabOD] = useState([]);

    // Paginazione
    const [currentPage, setCurrentPage] = useState(1);
    const [totalOnDemandPages, setTotalOnDemandPages] = useState(1);
    const [totalDownloadPages, setTotalDownloadPages] = useState(1);

    // Errori
    const [error1, setError] = useState(null);

    useEffect(() =>  { // trigger first search
        filteredSearch();
    }, [])

    const defaultModal = {
        modalTitle: "",
        modalText: "",
        confirmText: "",
        cancelText: "",
        show: false,
        handleClose: () => {
            updateModal({show: false});
        },
        handleHide: null,
        handleConfirm: null,
        handleCancel: null
    };
    const [modal, setModal] = useState(defaultModal);
    const updateModal = (updates, reset = false) => {
        const placeholder = reset ? defaultModal : modal;
        setModal({...placeholder, ...updates});
    }

    const handleCancelProfile = () => {
        updateModal({
            modalTitle: 'Confirm unsubscription to Mapitaly platform?',
            modalText: "This operation is irreversible and will result in no access to the platform",
            confirmText: "Ok",
            cancelText: "Cancel",
            show: true,
            handleConfirm: handleUnsubscription
        });
    }

    const handleUnsubscription = async () => {
        await axiosHandler.getInstance().post(`${process.env.REACT_APP_MAPIT_API_URL}${process.env.REACT_APP_MAPIT_UNSUBSCRIBE}`)
            .then((result) => {
                updateModal({
                    modalTitle: null,
                    modalText: "User has been unsubscribed",
                    confirmText: "Ok",
                    cancelText: null,
                    show: true,
                    handleHide: () => {
                        logout();
                    },
                    handleConfirm: () => {
                        logout();
                    }
                });
            });
    }

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setSelectedCurrentItems([]);
        setCurrentPage(1);
        setSelectAllChecked(false);
        setSelected([])
        setSelectedDownloads([])
        handleDeselectAll()
        setSelectAllChecked(false)
        filteredSearch(tab, 1)
    };

    const currentOrders = orderList
    //Per gestire download vuoto
    const currentDownloads = productList

    const handlePageChange = (page) => {
        setCurrentPage(page);
        setSelectedCurrentItems([]);
        setSelected([])
        setSelectedDownloads([])
        handleDeselectAll()
        setSelectAllChecked(false)
        filteredSearch(activeTab, page)
    };

    const handleOrderSelection = (item, isSelected) => {
        let newSelectedCurrentItems = [];
        if (isSelected) {
            // aggiungo gli item alla lista dei selectedCurrentItems
            const toParse = item.process.item_list.features;
            toParse.forEach((el) => {
                let itemObject = {};
                const itemActual = el.geometry.coordinates
                const reversedMultiPolygon = itemActual[0].map(polygon => {
                    return [polygon[1], polygon[0]];
                });
                const actualPolygon = turf.polygon([reversedMultiPolygon]);
                const actualPolygonCenter = turf.center(actualPolygon);
                itemObject = {
                    id: el.id,
                    center: actualPolygonCenter.geometry.coordinates,
                    polygon: actualPolygon.geometry.coordinates,
                    feature: actualPolygon.geometry,
                    showPolygon: false
                };
                newSelectedCurrentItems.push(itemObject);
            });
        } else {
            // devo togliere l'item dalla lista dei selectedCurrentItems
            newSelectedCurrentItems = selectedCurrentItems.filter(selectedCurrentOrder => selectedCurrentOrder.id !== item.id);
        }

        // aggiorno la variabile locale
        setSelectedCurrentItems(newSelectedCurrentItems);
        const currentMapIndex = currentMapKey.split("-")[1];
        setCurrentMapKey("map-" + (currentMapIndex + 1).toString());
    };

    const handleDownloadSelection = (index, item, isSelected) => {
        let newSelectedCurrentItems = [];
        let newItemsForDownload = [...selectedDownloads];
        // aggiungo booleano di isSelected alla lista di oggetti selezionati per "deselect all"
        const updatedSelected = [...selected]
        // const startIndexAct = (currentPage - 1) * itemsPerPage;
        // const index1 = startIndexAct + index;
        updatedSelected[index] = isSelected
        setSelected(updatedSelected)

        if (isSelected) {
            // mantengo la lista attuale
            newSelectedCurrentItems = selectedCurrentItems;

            // aggiungo gli item alla lista dei selectedCurrentItems
            const el = item.stac_item;
            let itemObject = {};
            const itemActual = el.geometry.coordinates
            const reversedMultiPolygon = itemActual.map(polygon => polygon.map(v => [v[1], v[0]]))
            const actualPolygon = turf.polygon(reversedMultiPolygon);
            const actualPolygonCenter = turf.center(actualPolygon);
            itemObject = {
                id: item.stac_item.id,
                center: actualPolygonCenter.geometry.coordinates,
                polygon: actualPolygon.geometry.coordinates,
                feature: actualPolygon.geometry,
                showPolygon: true
            };
            newSelectedCurrentItems.push(itemObject);

            //Per Multidownload
            newItemsForDownload[index] = item
            // newItemsForDownload.push(item)
        } else {
            // devo togliere l'item dalla lista dei selectedCurrentItems
            const itemsToMantain = selectedCurrentItems.filter((selectedCurrentItem) => {
                return selectedCurrentItem.id !== item.stac_item.id;
            });

            // const itemsToMaintainForDownload = selectedDownloads.filter(item => item).filter((selectedDownload) => {
            //     return selectedDownload.stac_item.id !== item.stac_item.id;
            // });
            const itemsToMaintainForDownload = selectedDownloads.filter((_, index1) => index1 !== index);

            newSelectedCurrentItems = itemsToMantain;
            newItemsForDownload = itemsToMaintainForDownload;
        }
        setSelectedDownloads(newItemsForDownload)
        setSelectedCurrentItems(newSelectedCurrentItems);
        const currentMapIndex = currentMapKey.split("-")[1];
        setCurrentMapKey("map-" + (currentMapIndex + 1).toString());
    };

    const handleDeselectAll = () => {
        setSelectedCurrentItems([]);
        setSelected([])
        setSelectedDownloads([])
        setSelectAllChecked(false)
    };

    const handleSelectAll = () => {
        const updatedSelected = productList ? productList.filter((download: any, index) => download.stac_item && download.stac_item.properties) : [];
        const selectedPolygons = itemsToPolygons(productList);

        setSelected(updatedSelected);
        setSelectedDownloads(productList ? productList : []);
        setSelectAllChecked(true);
        setSelectedCurrentItems(selectedPolygons);
    };

    // Multidownload
    const handleMultipleDownloads = (list: null) => {
        // preparo gli item da scaricare
        let items = [];
        if (list && Array.isArray(list)) {
            items = list;
        } else {
            items = selected?.map((value, i) => value ? i : value)
                .filter((num) => typeof num === 'number')
                .map((num) => productList[num])
                .filter((product) => product.stac_item && product.stac_item.properties && product.stac_item.properties.generation_type);
        }
        // TODO: far scaricare solo quelli ancora attivi (togliere il blocco in 'isDownloadAllDisabled')
        // invio alla coda di download
        
        addItemsToQueue(items.filter(selectedItem => selectedItem).map((selectedItem) => {
            // in entrambi i casi scarico sempre con NP perchè anche con ondemand l'item download contiene già il frame processato del job di riferimento
            let filename = '';
            const splittedFileUrl = selectedItem && selectedItem.stac_item && selectedItem.stac_item.assets && selectedItem.stac_item.assets.image ? selectedItem.stac_item.assets.image.href.split('/') : [];
            if (splittedFileUrl.length) {
                filename = splittedFileUrl[splittedFileUrl.length-1];
            }
            return {
                url: selectedItem.stac_item.properties.generation_type === "routine" ? `${process.env.REACT_APP_MAPIT_API_URL}${process.env.REACT_APP_MAPIT_API_ROUTINE_DOWNLOAD}${selectedItem.stac_item.id}`
                : `${process.env.REACT_APP_MAPIT_API_URL}${process.env.REACT_APP_MAPIT_API_NP_DOWNLOAD}${selectedItem.stac_item.properties.order_id}/${selectedItem.stac_item.properties.job_id}`,
                name: `STAC Item ${selectedItem.stac_item.id}`,
                filename
            }
        }));
    }

    // map elements, center, panning and layers -------------------------------------------------------------
    const defaultCenterCoordinates = [42.098222, 12.304688];
    const [centerCoordinates, setCenterCoordinates] = useState(defaultCenterCoordinates);
    const [mapChildren, setMapChildren] = useState([]);
    const [currentBounds, setCurrentBounds] = useState(null);
    const [currentZoom, setCurrentZoom] = useState(8);
    
    // useEffect(() => {
    //     const updateMapCenter = async () => {
    //         let currentMapCenterObject = null;
    //         //Se ci sono selectedCurrentItems, creo la feature collection di GeoJSon
    //         if (selectedCurrentItems && selectedCurrentItems.length) {
    //             const featureList = { type: "FeatureCollection", features: [] };
    //             selectedCurrentItems.forEach(item => {
    //                 const feature = turf.polygon(item.feature.coordinates);
    //                 featureList.features.push(feature);
    //             });
    //             currentMapCenterObject = turf.center(featureList);
    //         }
    
    //         if (currentMapCenterObject) {
    //             setCenterCoordinates(currentMapCenterObject.geometry.coordinates);
    //         } else if (navigator.geolocation) {
    //             navigator.geolocation.getCurrentPosition((position) => {
    //                 setCenterCoordinates([position.coords.latitude, position.coords.longitude]);
    //             });
    //         }
    //     };
    
    //     const updateMapChildren = () => {
    //         const layers = L.layerGroup();
    //         const updatedMapChildren = selectedCurrentItems.map((item, index) => {
    //             const layer = item.showPolygon ?
    //                 L.polygon(item.polygon, { color: '#e41b13', fillColor: '#e41b13' }) :
    //                 L.marker(item.center, { autoPan: true });
    //             layers.addLayer(layer);
    
    //             return item.showPolygon ? (
    //                 <Polygon key={`poly-${index}`} color="#e41b13" positions={item.polygon} />
    //             ) : (
    //                 <Marker key={`mark-${index}`} position={item.center} icon={markerIcon}>
    //                     <Popup>Item id: {item.id}</Popup>
    //                 </Marker>
    //             );
    //         });
    //         setMapChildren(updatedMapChildren);
    //         updateMapBounds(layers);
    //     };
    
    //     const updateMapBounds = (layers) => {
    //         const allCoordinates = [];
    //         Object.values(layers._layers).forEach(layer => {
    //             if (layer._latlngs) {
    //                 layer._latlngs.forEach(coords => {
    //                     const layerCoords = coords.map(coord => [coord.lng, coord.lat]);
    //                     allCoordinates.push(layerCoords);
    //                 });
    //             }
    //         });
    //         setCurrentBounds(panMapToBBoxBoundsCoordinates(mapRef, allCoordinates));
    //     };
    
    //     updateMapCenter();
    //     updateMapChildren();
    // }, [selectedCurrentItems, selectedDownloads]);

    useEffect (() => {
        // items and centering HOTFIX
        let currentMapCenterObject = null;
        if (selectedCurrentItems && selectedCurrentItems.length) {
            const featureList = {"type": "FeatureCollection", "features": []}
            selectedCurrentItems.forEach(item => {
                const feature = turf.polygon(item.feature.coordinates);
                featureList.features.push(feature);
            });
            currentMapCenterObject = turf.center(featureList);
        }
        // se ho trovato il centro...
        if (currentMapCenterObject) {
            console.log('Map position:', currentMapCenterObject.geometry.coordinates);
            setCenterCoordinates(currentMapCenterObject.geometry.coordinates);
        } else if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                console.log('User position:', latitude, longitude);
                setCenterCoordinates([latitude, longitude]);
            });
        } else {
            console.log('Geolocation is not supported by this browser.');
        }

        // layers to draw
        const layers = L.layerGroup();
        let updatedMapChildren = selectedCurrentItems.map((item, index) => {
            let layer = null;
            if (item.showPolygon) {
                layer = L.polygon(item.polygon, {color: '#e41b13', fillColor: '#e41b13'} );
            } else {
                layer = L.marker(item.center, {autoPan: true});
            }
            layers.addLayer(layer);
            return item.showPolygon ? (
                    <Polygon key={`poly-${index}`} color="#e41b13" positions={item.polygon}/>
                ) :
                (
                    <Marker key={`mark-${index}`} position={item.center} icon={markerIcon}>
                        <Popup>
                            Item id: {item.id}
                        </Popup>
                    </Marker>
                )
        });
        setMapChildren(updatedMapChildren);

        // bounds and panning
        if (layers && layers._layers) {
            let allCoordinates = [];
            Object.keys(layers._layers).forEach((layerKey) => {
                if (layers._layers[layerKey]._latlng) {

                } else if (layers._layers[layerKey]._latlngs) {
                    layers._layers[layerKey]._latlngs.forEach((coords) => {
                        const allLayerCoords = coords.map((layerCoords) => ([layerCoords.lng, layerCoords.lat]));
                        allCoordinates.push(allLayerCoords);
                    });
                }
            })
            setCurrentBounds(panMapToBBoxBoundsCoordinates(mapRef, allCoordinates));
            if (selectedDownloads.length >= 2 && selectedCurrentItems.length >= 2) {
                setCurrentZoom(6)
                console.log(selectedDownloads.length, selectedCurrentItems.length, "currentzoom 6")
            } else {
                setCurrentZoom(8)
                console.log(selectedDownloads.length, selectedCurrentItems.length, "currentzoom 8")
            }
        }
    }, [selectedCurrentItems, selectedDownloads]);

    const isDownloadAvailable = (download) => {
        try {
            return download.stac_item.properties.status === 'valid';
        } catch (error) {
            console.error(error);
            // return false;
        }
    };

    const isDownloadAllDisabled = useMemo(() =>
            !selectedDownloads.length || !selectedDownloads.every((item, index) => isDownloadAvailable(item)),
        [selectedDownloads, isDownloadAvailable])

    const renderStatus = (status) => {
        if (status === "running") {
            return <div><HourglassSplit alt={status} /> {status}</div>
        } else if (status === "expired") {
            return <div><HourglassBottom alt={status} /> {status}</div>
        } else if (status === "finished") {
            return <div><Check alt={status} /> {status}</div>
        } else {
            return <div><Exclamation alt={status} /> {status}</div>
        }
    }


    const renderCurrentOrderItems = (currOrd) => {
        return currOrd ? currOrd.map((order, index) => {
            return (
                <tr key={`curord-${index}`}>
                    <td align="center">
                        <input
                            type="radio"
                            name="selectedItem"
                            onChange={(e) => handleOrderSelection(order, e.target.checked)}
                        />
                    </td>
                    <td>{order.job_id}</td>
                    <td>{order.description}</td>
                    <td>{formatDate(order.created)}</td>
                    <td>{formatDate(order.updated)}</td>
                    <td>{renderStatus(order.status)}</td>
                    <td align="center">
                        <Link to={`/profile/details/${order.job_id}`}>
                            <Button className='button1'>
                                <BoxArrowRight />
                            </Button>
                        </Link>

                    </td>
                </tr>
            )
        }) : null
    };

    const renderCurrentDownloadItems = (currDownl) => {
        let result = null;
        if (currDownl) {
            result = currDownl.map((download: any, index) => {
                if (download.stac_item && download.stac_item.properties) {
                    return (
                        <tr key={`curdwn-${index}`}>
                            <td align="center">
                                <input
                                    type="checkbox"
                                    name="selectedItem"
                                    checked={selected[index]}
                                    onChange={(e) => handleDownloadSelection(index, download, e.target.checked)}
                                />
                            </td>

                            <td>{download.stac_item.properties.generation_type === "routine" ? download.stac_item.properties.tile_id : download.stac_item.properties.reference_strip}</td>
                            <td>{download.stac_item.properties.generation_type !== "routine" ? download.stac_item.properties.order_id : "-"}</td> {/* TODO: da servizio deve tornare la description ordine */}
                            <td>{download.stac_item.properties.generation_type !== "routine" ? download.stac_item.properties.job_id : "-" }</td> {/* TODO: da servizio deve tornare la data ordine */}
                            <td>{formatDate(download.datetime)}</td>
                            <td>{capitalizeFirst(download.stac_item.properties.generation_type)}</td>

                            <td className='text-center'>
                                <Button className='button1'
                                        onClick={() => {
                                            download.stac_item.properties.generation_type === "routine" ? handleMultipleDownloads([download]) : handleMultipleDownloads([download])
                                        }} disabled={!isDownloadAvailable(download)}>
                                    <ArrowDown />
                                </Button>
                            </td>
                        </tr>
                    )
                } else {
                    return (
                        <tr key={`curdwn-${index}`}>
                            <td align="center">
                                -
                            </td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td className='text-center'>
                                -
                            </td>
                        </tr>
                    )
                }
            })
        }
        return result;
    }

    const renderUserInfo = (user): JSX => {
        const labelConversion = {
            name: 'Name',
            email: 'E-Mail'
        }
        return user ? Object.keys(user).map((infoLabel) => {
            const infoValue = user[infoLabel];
            return (infoValue && typeof infoValue === 'string' && labelConversion.hasOwnProperty(infoLabel)) ?
                    <p key={`userinfo-${infoLabel}`} className='userinfo-data'>
                        <span className='label'>{labelConversion[infoLabel]}</span>
                        <span className='value'>{infoValue}</span>
                    </p> : null
        }) : '';
    }

    const renderCurrentItems = () => {
        const itemsToRender = activeTab === 'orders' ? currentOrders : currentDownloads;
        return activeTab === 'orders' ? renderCurrentOrderItems(itemsToRender) : renderCurrentDownloadItems(itemsToRender)
    };

    return (
        <>
            <div className="m-5" style={{paddingTop: '60px'}}>
                <Row>
                    <Col className='col-12 col-lg-3'>
                        <h3>Account Informations</h3>
                        {renderUserInfo(user)}
                        <Button className='button1 d-flex justify-content-left mb-3'
                                onClick={handleCancelProfile}>Unsubscribe</Button>
                    </Col>
                    <Col className='col-12 col-lg-9'>
                        <MapContainer
                            crs={Leaflet.CRS.EPSG3857}
                            ref={mapRef}
                            style={{maxHeight: "400px", marginBottom: "30px"}}
                            bounds={currentBounds}
                            maxBounds={Leaflet.latLngBounds(
                                Leaflet.latLng(-90, -180),
                                Leaflet.latLng(90, 180)
                            )}
                            key={`mapkey-${currentMapKey}`}
                            center={centerCoordinates}
                            zoom={8}
                            maxZoom={17}
                            minZoom={3}
                            height={100}
                            scrollWheelZoom={true}
                            trackResize
                            children={mapChildren}
                        >
                            {/*<TileLayer*/}
                            {/*    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'*/}
                            {/*    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"*/}
                            {/*/>*/}

                            <FeatureGroup ref={drawRef}>
                                <EditControl
                                    position='topright'
                                    onCreated={handleAOIdraw}
                                    onDeleted={handleAOIdeletion}
                                    edit={{ remove: true, edit: false }}
                                    draw={{
                                        rectangle: false,
                                        circle: true,
                                        polyline: false,
                                        polygon: {
                                            showArea: true,
                                            showLength: true,
                                            metric: ["km", "m"],
                                            feet: false,
                                            nautic: false,
                                        },
                                        marker: false,
                                        circlemarker: false,
                                    }}
                                />
                                <LayersControl position="topright">
                                    <BaseLayer checked name="Streets map">
                                        <TileLayer
                                            className="map-layer-view"
                                            attribution="Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012"
                                            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
                                        />
                                    </BaseLayer>
                                    <BaseLayer name="Dark map">
                                        <TileLayer
                                            className="map-layer-view"
                                            url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                                            attribution={
                                                "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors &copy; <a href=\"https://carto.com/attributions\">CARTO</a>"
                                            }
                                        />
                                    </BaseLayer>
                                    <BaseLayer name="Topographic map">
                                        <TileLayer
                                            className="map-layer-view"
                                            attribution="Tiles &copy; Esri &mdash; Esri, DeLorme, ... , Esri China (Hong Kong), and the GIS User Community"
                                            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
                                        />
                                    </BaseLayer>
                                    <BaseLayer name="Satellite map">
                                        <TileLayer
                                            className="map-layer-view"
                                            attribution="Tiles &copy; Esri &mdash; Esri, DeLorme, ... , Esri China (Hong Kong), and the GIS User Community"
                                            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                        />
                                    </BaseLayer>
                                    <BaseLayer name="Satellite map with labels">
                                        <LayerGroup>
                                            <TileLayer
                                                className="map-layer-view"
                                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                                attribution={
                                                    "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors &copy; <a href=\"https://carto.com/attributions\">CARTO</a>"
                                                }
                                            />
                                            <TileLayer
                                                className="map-layer-view"
                                                attribution="Tiles &copy; Esri &mdash; Esri, DeLorme, ... , Esri China (Hong Kong), and the GIS User Community"
                                                url="https://{s}.basemaps.cartocdn.com/dark_only_labels/{z}/{x}/{y}.png"
                                            />
                                        </LayerGroup>
                                    </BaseLayer>
                                </LayersControl>
                            </FeatureGroup>
                            {
                                mapChildren
                            }
                            <FlyToMap 
                            center={centerCoordinates} zoom={currentZoom}/>

                        </MapContainer>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col className='col-12 col-lg-3 mb-5'>
                        {activeTab === 'orders' && renderFilterForm()}
                    </Col>
                    <Col className='col-12 col-lg-9'>
                        {!isLoading && error1 && <div className="mt-3 alert alert-danger">
                            <Row className="justify-content-between">
                                <Col className="col-auto">
                                    {error1}
                                </Col>
                                <Col className="col-auto">
                                    <ArrowClockwise style={{cursor: "pointer"}} onClick={() => {
                                        filteredSearch()
                                    }} />
                                </Col>
                            </Row>
                        </div>}

                        <Nav fill variant="tabs" defaultActiveKey="orders" className={"py-0" + (isLoading ? " deactivated" : null)} onSelect={handleTabChange}>
                            <Nav.Item>
                                <Nav.Link style={{borderTopRightRadius: 0}} eventKey="orders" className='nav-tabs'>On
                                    Demand
                                    Processing</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link style={{borderTopLeftRadius: 0}} eventKey="downloads"
                                          className='nav-tabs '>Downloads</Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Table striped bordered hover responsive className='a1Tab'>
                            <thead>
                                {activeTab === 'orders' && renderColumnNames(activeTab, [' ', 'Order ID', 'Order Description', 'Order Date', 'Completion Date', 'Status', 'Details'])}
                                {activeTab === 'downloads' && renderColumnNames(activeTab, ['Tile ID', 'Order ID', 'Frame ID', 'Download Date', 'Generation Type', 'Download'])}
                            </thead>

                            <tbody>
                                {renderCurrentItems()}
                            </tbody>
                        </Table>

                        <Row className='d-flex' style={{paddingBottom: '20px'}}>
                            {activeTab === 'downloads' &&
                                <Col>
                                    <Button disabled={isDownloadAllDisabled}
                                            className='button1 d-flex justify-content-left mb-3'
                                            onClick={handleMultipleDownloads}>Download Selected</Button>
                                </Col>
                            }

                            <ProfilePagination
                                {...{
                                activeTab,
                                totalOnDemandPages,
                                totalDownloadPages,
                                handlePageChange,
                                currentPage,
                                totalItems,
                                isLoading,
                            }} />
                        </Row>
                    </Col>
                </Row>
            </div>
            <MapitalyModal {...modal}></MapitalyModal>
        </>
    );
};

const mapStateToProps = state => ({
    user: state.auth.user,
    isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
    logout,
    addItemsToQueue
})(Profile);

export const extractBBoxByCoordinates = (
    allCoordinates: any[]
): any | null => {
    const bbox:any = {};
    allCoordinates
        .forEach((coordinates: CoordinatesType) => {
            const minLong = Math.min(...coordinates.map((coords) => coords[0]));
            const maxLong = Math.max(...coordinates.map((coords) => coords[0]));

            const minLat = Math.min(...coordinates.map((coords) => coords[1]));
            const maxLat = Math.max(...coordinates.map((coords) => coords[1]));

            if (!bbox.minLat || bbox.minLat > minLat) bbox.minLat = minLat;
            if (!bbox.maxLat || bbox.maxLat < maxLat) bbox.maxLat = maxLat;

            if (!bbox.minLong || bbox.minLong > minLong) bbox.minLong = minLong;
            if (!bbox.maxLong || bbox.maxLong < maxLong) bbox.maxLong = maxLong;
        });

    return hasBeenFilled(bbox.minLat) && hasBeenFilled(bbox.minLong) && hasBeenFilled(bbox.maxLat) && hasBeenFilled(bbox.maxLong)
        ? bbox
        : null
};

export const hasBeenFilled = (value): boolean => {
    const type = typeof value

    return type === "object" && value !== null
        ? Object.keys(value).length > 0
        : value !== null && value !== undefined && value !== ""
}

export const panMapToBBoxBoundsCoordinates = (mapRef, allCoordinates: any[]) => {
    const bbox = extractBBoxByCoordinates(allCoordinates);
    let currentBounds = null;
    if (!!mapRef && !!bbox) {
        const map = mapRef.current;
        if (map) {
            currentBounds = [
                [bbox.minLat, bbox.minLong],
                [bbox.minLat, bbox.maxLong],
                [bbox.maxLat, bbox.maxLong],
                [bbox.maxLat, bbox.minLong],
            ]
            map.fitBounds(currentBounds, {
                padding: [50, 50] 
            });
            // console.log("padding applied!!!")
        }
    }
    return currentBounds;
};
